import LoadingIcon from './LoadingIcon.jsx'

export default LoadingIcon
